/**
 * Processa dados da API para o formato do frontend
 * @param {Array} contas - Array de contas vindas da API
 * @returns {Array} Array de contas processadas
 */
export const processarContas = (contas) => {
  return contas.map(conta => {
    // Parse da data no formato DD/MM/YYYY
    const [dia, mes, ano] = conta.data_vencimento.split('/');
    const dataVencimento = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
    
    // Normalizar hoje para meia-noite para comparação correta
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    dataVencimento.setHours(0, 0, 0, 0);
    
    // Verificar se a data é válida e calcular dias de vencimento apenas para contas em aberto
    const isDataValida = !isNaN(dataVencimento.getTime());
    const diasVencimento = (isDataValida && conta.status === 'A') ? Math.ceil((dataVencimento - hoje) / (1000 * 60 * 60 * 24)) : 0;
    
    // Determinar status baseado no campo status da API
    let status = 'proximos_meses';
    
    if (conta.status === 'F') {
      status = 'recebida';
    } else if (conta.status === 'C') {
      status = 'cancelada';
    } else if (conta.status === 'P') {
      status = 'recebida_parcialmente';
    } else if (conta.status === 'A') {
      // Para contas não recebidas, usar data de vencimento
      if (diasVencimento < 0) {
        status = 'vencida';
      } else if (diasVencimento === 0) {
        status = 'hoje';
      } else if (diasVencimento <= 7) {
        status = 'proxima_vencimento';
      } else {
        // Verificar se vence ainda neste mês
        const mesVencimento = dataVencimento.getMonth();
        const anoVencimento = dataVencimento.getFullYear();
        const mesAtual = hoje.getMonth();
        const anoAtual = hoje.getFullYear();
        
        // Se vence ainda neste mês, usar 'proxima_vencimento' em vez de 'proximos_meses'
        if (mesVencimento === mesAtual && anoVencimento === anoAtual) {
          status = 'proxima_vencimento';
        }
        // Caso contrário, mantém 'proximos_meses' (vence em meses futuros)
      }
    }

    return {
      id: conta.id,
      cliente: conta.cliente || conta.fornecedor, // Adaptar campo
      fornecedor: conta.cliente || conta.fornecedor, // Manter compatibilidade
      observacao: conta.observacao,
      descricao: conta.observacao || conta.conta_analitica,
      valor: parseFloat(conta.valor),
      vencimento: conta.data_vencimento,
      dataVencimento: dataVencimento, // Adicionar objeto Date para ordenação
      status: status,
      conta_analitica: conta.conta_analitica,
      id_conta_analitica: conta.id_conta_analitica,
      categoria: conta.planejamento || 'Sem planejamento',
      subcategoria: conta.conta_analitica || 'Sem subcategoria',
      planejamento: conta.planejamento,
      id_planejamento: conta.id_planejamento,
      prioridade: (conta.status === 'A' && diasVencimento < 0) ? 'alta' : 
                 (conta.status === 'A' && diasVencimento <= 7) ? 'media' : 'baixa',
      diasVencimento: diasVencimento,
      documento: conta.documento,
      tipo_recebimento: conta.tipo_recebimento || conta.tipo_pagamento, // Adaptar campo
      conta: conta.conta,
      valor_aberto: parseFloat(conta.valor_aberto),
      valor_recebido: parseFloat(conta.valor_recebido || conta.valor_pago), // Adaptar campo
      data_recebimento: conta.data_recebimento || conta.data_pagamento || null, // Adaptar campo
      // Adicionar campo dataRecebimento (Date) para ordenação
      dataRecebimento: (() => {
        const dataRec = conta.data_recebimento || conta.data_pagamento;
        if (!dataRec) return null;
        try {
          const dataStr = String(dataRec).trim();
          const matchBrasileiro = dataStr.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}):(\d{2}))?/);
          if (matchBrasileiro) {
            const [, dia, mes, ano, hora = '00', minuto = '00', segundo = '00'] = matchBrasileiro;
            const dateObj = new Date(`${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}`);
            if (!isNaN(dateObj.getTime())) {
              return dateObj;
            }
          }
          const dateISO = new Date(dataStr);
          if (!isNaN(dateISO.getTime())) {
            return dateISO;
          }
          return null;
        } catch {
          return null;
        }
      })(),
      arquivos: (() => {
        // Função auxiliar para verificar se um arquivo é válido (tem pelo menos um campo não-null)
        const arquivoValido = (arq) => {
          if (!arq || typeof arq !== 'object') return false;
          // Verificar se pelo menos um campo importante não é null ou vazio
          const camposImportantes = ['id', 'descricao', 'arquivo', 'data_envio', 'extensao'];
          return camposImportantes.some(campo => {
            const valor = arq[campo];
            return valor !== null && valor !== undefined && valor !== '';
          });
        };
        
        // Processar campo arquivos - pode vir como string JSON ou array
        if (!conta.arquivos) return [];
        if (Array.isArray(conta.arquivos)) {
          return conta.arquivos.filter(arquivoValido);
        }
        try {
          const parsed = JSON.parse(conta.arquivos);
          if (Array.isArray(parsed)) {
            return parsed.filter(arquivoValido);
          }
        } catch (e) {
          console.warn('Erro ao parsear arquivos:', e);
        }
        return [];
      })()
    };
  });
};

